import { Result } from "@/functional/result";
import { getCookie } from "typescript-cookie";

export class RestClientHeader {
  private getXsrfCookie(): string | undefined {
    return getCookie("XSRF-TOKEN");
  }

  public getHeader(withCookies: boolean): Result<Map<string, string>> {
    const headerMap = new Map();
    
    const cookie: string | undefined = this.getXsrfCookie();
    if (cookie === undefined && withCookies)
      Result.fail<Map<string, string>>("Cookie for XSRF-TOKEN not found.");

    if (withCookies) headerMap.set("x-xsrf-token", cookie);
    headerMap.set("Accept", "application/json");
    headerMap.set("Content-Type", "application/json");

    return Result.ok<Map<string, string>>(headerMap);
  }
}
